import { FETCH_PROMOTION } from './types';
import salomapi from '../apis';

export const fetchPromotion = (params) => async dispatch => {
  const response = await salomapi.get('promotions/?slug=' + params.promotionId);
  dispatch({ type: FETCH_PROMOTION, payload: response.data })
}

